import { render } from "./Pixel.vue?vue&type=template&id=6bd9898e"
import script from "./Pixel.vue?vue&type=script&lang=js"
export * from "./Pixel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__